import axios from "axios";

const baseURL =
  process.env.VUE_APP_API_BASE_URL || "http://localhost:8002/api/branch";

function apiHeaders() {
  const token = localStorage.getItem("shams_branches_dash_Token");
  const lang = localStorage.getItem("shams_branches_dash_lang") || "ar";

  return {
    Accept: "application/json",
    "Accept-language": lang,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

function countUnread(notifications) {
  if (!Array.isArray(notifications)) {
    return 0;
  }

  return notifications.filter((item) => !item.is_readed && !item.read_at).length;
}

export default {
  getNotifications(context) {
    return axios
      .get(`${baseURL}/notification`, { headers: apiHeaders() })
      .then((res) => {
        const items = res.data.data || [];
        context.commit("setNotifications", items);
        context.commit("setUnread", countUnread(items));
        if (res.data.unread_count !== undefined) {
          context.commit("setUnreadMes", res.data.unread_count);
        }
      })
      .catch(() => {});
  },
  getUnRead(context) {
    return axios
      .get(`${baseURL}/unread-notification-count`, { headers: apiHeaders() })
      .then((res) => {
        context.commit("setUnreadMes", res.data.data.unread);
      })
      .catch(() => {
        context.commit("setUnreadMes", countUnread(context.state.notifications));
      });
  },
};
